import React from "react";
import { HStack, Text, Pressable, Box, ScrollView, Button } from "native-base";
import { useTranslation } from "react-i18next";

import colors from "theme/colors";
import { AiOutlineDownload, AiOutlineSend } from "react-icons/ai";
import { LiaMoneyBillSolid } from "react-icons/lia";
import { BiTrashAlt } from "react-icons/bi";
import { SD_LANDING_PAGE } from "global/paths";
import { getColorForSDRequestTab, numberWithDotsAndNegativeCase } from "utils/helpers";

import CreateModal from "molecules/CreateModal";
import CustomTable from "molecules/CustomTable";
import PaginationMui from "molecules/Pagination";
import ContentContainer from "atoms/ContentContainer";
import Breadcrumbs from "atoms/Breadcrumbs";
import InfoBox from "atoms/InfoBox";
import SummaryBox from "atoms/SummaryBox";
import NoData from "atoms/NoData";
import { styles } from "pages/SDScheduledData/styles";
import { getHeaders, getFields } from "pages/SDScheduledData/constants";
import useSdScheduledData from "pages/SDScheduledData/connect";
import { CREATE_MODALS } from "global/constants";

const SDScheduledData = ({ isMinimize, userEmail = "" }) => {
  const { t } = useTranslation("common");

  const {
    sdRequestVerifiedListData,
    sdRequestRejectedListData,
    submitScheduling,
    wipeSdScheduling,
    handleSendData,
    handleWipe,
    currentPage,
    setCurrentPage,
    selectedTab,
    setSelectedTab,
    selectedRows = [],
    setSelectedRows,
    tabs,
    isAllRowSelected,
    setIsAllRowSelected,
    currentData,
    modal,
    setModal,
    requestId,
    excludedRows,
    setExcludedRows,
  } = useSdScheduledData();

  const onChangeTab = (tab) => {
    setSelectedTab(tab);
    setCurrentPage(1);
  };

  const onDownloadPress = () => {
    setModal({
      ...modal,
      type: CREATE_MODALS.exportSDDataDitolak,
      data: { email: userEmail, requestId, status: "failed" },
    });
  };

  const renderTabButtons = () => {
    let totalNominal = 0;

    if (selectedTab.includes("verifiedTab")) {
      const selectedRowData = isAllRowSelected ? excludedRows || [] : selectedRows || [];

      const selectedRowsTotal = selectedRowData.reduce((total, row) => total + parseFloat(row?.amount), 0);

      totalNominal =
        isAllRowSelected && excludedRows.length > 0
          ? (currentData?.data?.totalAmount || 0) - selectedRowsTotal
          : isAllRowSelected
          ? currentData?.data?.totalAmount
          : selectedRowsTotal;
    }

    const shouldButtonsBeDisabled = selectedRows.length === 0;

    return (
      <>
        <HStack space={2} ml="15px" my="16px">
          {tabs.map((tab) => {
            const tabTotal = tab.includes("rejectedTab") ? sdRequestRejectedListData : sdRequestVerifiedListData;
            return (
              <Pressable
                borderRadius="16px"
                px="16px"
                py="4px"
                backgroundColor={getColorForSDRequestTab({
                  tabName: tab,
                  colorType: "backgroundColor",
                  selectedTab,
                })}
                borderWidth="1px"
                borderColor={getColorForSDRequestTab({
                  tabName: tab,
                  colorType: "borderColor",
                  selectedTab,
                })}
                onPress={() => onChangeTab(tab)}
              >
                <Text
                  fontWeight="semibold"
                  color={getColorForSDRequestTab({
                    tabName: tab,
                    colorType: "textColor",
                    selectedTab,
                  })}
                >
                  {t(tab).concat(" ")}
                  {`(${tabTotal?.count || 0})`}
                </Text>
              </Pressable>
            );
          })}
        </HStack>

        <HStack alignItems="center" justifyContent="space-between" mx="15px" my="16px" flexWrap="wrap">
          <HStack mb="8px">
            {(selectedRows.length > 0 || isAllRowSelected) && selectedTab.includes("verifiedTab") && (
              <Box my={1} mr="16px" style={styles.boxContainer}>
                <HStack alignItems="center">
                  <Text fontSize="md" fontWeight="medium" style={{ color: colors.variants.clover }}>
                    {isAllRowSelected ? (currentData?.count || 0) - excludedRows.length : selectedRows.length}
                    {" / ".concat(currentData?.count || 0)}
                  </Text>
                  <Text>{" ".concat(t("salaryDisbursement.SDRequestBox.selectedData"))}</Text>
                </HStack>
              </Box>
            )}
            <Box my={1} style={styles.boxContainer}>
              <HStack justifyContent="space-between">
                <HStack style={{ alignItems: "center" }}>
                  <LiaMoneyBillSolid size="16px" style={{ marginRight: 4 }} />
                  <Text>{t("salaryDisbursement.SDRequestBox.totalNominal")}</Text>
                </HStack>
                <Text fontSize="md" fontWeight="medium" style={{ color: colors.variants.clover }}>
                  {numberWithDotsAndNegativeCase(totalNominal)}
                </Text>
              </HStack>
            </Box>
          </HStack>
          {selectedTab.includes("verifiedTab") && (
            <HStack alignItems="center" space={3}>
              <Button
                variant={shouldButtonsBeDisabled && !isAllRowSelected ? "outline" : "solid"}
                backgroundColor={getColorForSDRequestTab({
                  shouldButtonsBeDisabled: shouldButtonsBeDisabled && !isAllRowSelected,
                  colorType: "buttonBackgroundColor",
                })}
                borderRadius="4px"
                onPress={submitScheduling}
              >
                <HStack alignItems="center">
                  <Text
                    variant="xs"
                    color={getColorForSDRequestTab({
                      shouldButtonsBeDisabled: shouldButtonsBeDisabled && !isAllRowSelected,
                      colorType: "buttonTextColor",
                    })}
                  >
                    {t("salaryDisbursement.SDRequestBox.submitScheduling")}
                  </Text>
                  <AiOutlineSend
                    color={getColorForSDRequestTab({
                      shouldButtonsBeDisabled: shouldButtonsBeDisabled && !isAllRowSelected,
                      colorType: "buttonTextColor",
                    })}
                    size="16px"
                    style={{ marginLeft: 4 }}
                  />
                </HStack>
              </Button>
              <Button
                variant="outline"
                backgroundColor={getColorForSDRequestTab({
                  shouldButtonsBeDisabled: shouldButtonsBeDisabled && !isAllRowSelected,
                  colorType: "transparentButtonBackgroundColor",
                })}
                borderColor={getColorForSDRequestTab({
                  shouldButtonsBeDisabled: shouldButtonsBeDisabled && !isAllRowSelected,
                  colorType: "redButtonBorderColor",
                })}
                leftIcon={
                  <BiTrashAlt
                    size="15px"
                    color={getColorForSDRequestTab({
                      shouldButtonsBeDisabled: shouldButtonsBeDisabled && !isAllRowSelected,
                      colorType: "redButtontextColor",
                    })}
                  />
                }
                onPress={wipeSdScheduling}
              >
                <Text
                  variant="sm"
                  color={getColorForSDRequestTab({
                    shouldButtonsBeDisabled: shouldButtonsBeDisabled && !isAllRowSelected,
                    colorType: "redButtontextColor",
                  })}
                >
                  {t("salaryDisbursement.SDRequestBox.wipe")}
                </Text>
              </Button>
            </HStack>
          )}
          {selectedTab.includes("rejectedTab") && (
            <Pressable onPress={onDownloadPress} isDisabled={requestId === ""}>
              <HStack
                alignItems="center"
                space="2"
                borderWidth={1}
                borderColor={colors.disabled.smoke}
                borderRadius={4}
                padding={2}
              >
                <Text fontSize="xs">{t("transactionPage.downloadData")}</Text>
                <AiOutlineDownload size="17px" />
              </HStack>
            </Pressable>
          )}
        </HStack>
      </>
    );
  };

  return (
    <>
      <ContentContainer title={t("salaryDisbursement.SDRequestBox.title")} flex={[1, 1, 1, 0.85, 0.85]}>
        <Breadcrumbs
          currentPage="sideBar.sdScheduledData"
          parentScreen={[{ name: "sideBar.salaryDisbursement", link: SD_LANDING_PAGE }]}
          style={{ marginTop: "10px", marginHorizontal: "0px" }}
        />
        <InfoBox
          title={
            selectedTab.includes("rejectedTab")
              ? t("salaryDisbursement.SDRequestBox.checkRejectedDataByDownloadingData")
              : t("salaryDisbursement.SDRequestBox.warningBeforeSendingSdRequest")
          }
          warning={selectedTab.includes("verifiedTab")}
          alert={selectedTab.includes("rejectedTab")}
        />
        <SummaryBox title={t("salaryDisbursement.table.header.title")} maxWidth="1400px">
          {renderTabButtons()}

          <ScrollView pb="50px">
            {(currentData?.data?.records || []).length === 0 ? (
              <NoData />
            ) : (
              <>
                <CustomTable
                  isMinimize={isMinimize}
                  data={currentData?.data?.records}
                  headers={getHeaders(selectedTab)}
                  fields={getFields(selectedTab)}
                  showCheckboxes={selectedTab.includes("verifiedTab")}
                  selectedRows={selectedRows}
                  isAllRowSelected={isAllRowSelected}
                  setIsAllRowSelected={setIsAllRowSelected}
                  setSelectedRows={setSelectedRows}
                  skip={(currentPage - 1) * 50}
                  excludedRows={excludedRows}
                  setExcludedRows={setExcludedRows}
                />
                <PaginationMui
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPageNumber={Math.ceil((currentData?.count || 0) / 50)}
                />
              </>
            )}
          </ScrollView>
        </SummaryBox>
      </ContentContainer>
      <CreateModal handleSendData={handleSendData} handleWipe={handleWipe} />
    </>
  );
};

export default SDScheduledData;
